__turbopack_context__.v({
  "className": "gilroyfont_3c05673f-module__Hrrzlq__className",
});
